<template>
  <div class="dropdown-block">
    <div class="heading" v-if="this.info">
      {{ label }}
      <img v-if="toolTip" :src="getImage('question-icon.svg')" alt="" @click="openPopup">
    </div>
    <div class="heading" v-else>
      {{ label }}
    </div>
    <slot/>
  </div>
</template>

<script>
import ItemIcon from '../../input/InformationIcon';
import tooltipMixin from "../../../mixins/tooltipMixin";

export default {
  name: 'MenuItem',
  mixins: [tooltipMixin],
  props: {
    label: {
      default: 'Placeholder label'
    },
    info: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    ItemIcon,
  },
  methods: {
    onClick(val) {
      this.$emit('clickItem', val)
    },
    openPopup() {
      this.$store.commit('tooltips/setCurrentActive', this.toolTip);
    }
  },
}
</script>

<style lang="scss">
.dropdown-block {

  select {
    border-radius: 50px;
    border: 2px solid #EBEBEB;
    height: 40px;
    font-size: 12px;

    &:focus, :active {
      outline: none;
      box-shadow: none;
      border-color: #EBEBEB;
    }

  }

  .input-group {
    padding-bottom: 8px;
    z-index: 1;

    input {
      border-radius: 50px;
      height: 40px;
      border: 2px solid #EBEBEB;
      font-size: 12px;

      &:focus, :active {
        outline: none;
        border: 2px solid #EBEBEB;
        box-shadow: none;
      }
    }

    .input-group-text {
      background-color: #EBEBEB;
      height: 40px;
      border-radius: 0 50px 50px 0;
      border: none;
      font-size: 12px;
    }
  }

  .heading {
    font-family: neue-haas-grotesk-display, sans-serif;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    margin-bottom: 6px;
    position: relative;

    .link {
      text-decoration: underline;
      font-size: 12px;
      font-weight: normal;
      margin-top: 2px;
      position: absolute;
      right: 25px;
      top: 0;
      cursor: pointer;
      transition: all ease 0.2s;
      color: rgba(0, 0, 0, 0.4);

      &:hover {
        color: #3DB0C7;
      }
    }

    img {
      cursor: pointer;
      margin-left: auto;
      transition: all ease 0.3s;

      &:hover {
        transform: scale(1.2);
      }
    }
  }
}

.tooltip {
  opacity: 1;
}
</style>
